/* @flow */
import * as React from 'react';
import AddedDeviceVerifier from 'app/components/AddedDeviceVerifier';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';

import ToastActions from 'actions/ToastActions';

type Props = {
  onRequestHide?: Function,
  pendingSmsDeviceId: number,
  refetch?: Function,
};

export default class AddedDeviceVerifierModal extends React.Component<Props> {
  handleSmsDeviceVerificationSuccess = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
    if (this.props.refetch) {
      this.props.refetch();
    }
    ToastActions.showSuccessToast('The device has been succesfully verified, thank you.');
  };

  handleSmsDeviceRejectionSuccess = () => {
    if (this.props.onRequestHide) {
      this.props.onRequestHide();
    }
    if (this.props.refetch) {
      this.props.refetch();
    }
  };

  render() {
    return (
      <Dialog size="small" {...this.props}>
        <BoxBody>
          <AddedDeviceVerifier
            closable
            onVerificationSuccess={this.handleSmsDeviceVerificationSuccess}
            onRejectionSuccess={this.handleSmsDeviceRejectionSuccess}
            pendingSmsDeviceId={this.props.pendingSmsDeviceId}
          />
        </BoxBody>
      </Dialog>
    );
  }
}
